import React, { ReactNode, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from "../context/AppContext";

interface CreatePasswordGuardProps {
    children: ReactNode;
}

const CreatePasswordGuard: React.FC<CreatePasswordGuardProps> = ({ children }) => {
    const { authState } = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
        const isPasswordSet = localStorage.getItem('isPasswordSet');
        if (!authState.authenticated || isPasswordSet === 'true') {
            navigate('/login');
        }
    }, [authState, navigate]);
    return authState.authenticated && localStorage.getItem('isPasswordSet') === 'false' ? <>{children}</> : null;
};

export default CreatePasswordGuard;
